import PropTypes from 'prop-types';
import React, { Component } from 'react';

const styles = {
  container: {
    margin: 10,
    textAlign: 'justify',
    fontFamily: 'Raleway',
  },
  link: {
    textDecoration: 'underline',
  },
  list: {
    fontWeight: '600',
    listStyle: 'disc',
    marginBottom: 20,
  },
};

// eslint-disable-next-line react/prefer-stateless-function
export default class PrivacyPolicy extends Component {
  static propTypes = {
    style: PropTypes.object,
  };

  render() {
    const { style } = this.props;
    const cookiePolicyLink = (
      <a
        href='#cookie-policy'
        style={styles.link}
      >
        Cookie Policy
      </a>
    );
    const privacyEmailLink = (
      <a
        style={styles.link}
        href='mailto:privacy@ripplestreet.com'
      >
        privacy@ripplestreet.com
      </a>
    );
    const ccpaEmailLink = (
      <a
        style={styles.link}
        href='mailto:ccparequests@ripplestreet.com'
      >
        ccparequests@ripplestreet.com
      </a>
    );
    const csEmailLink = (
      <a
        style={styles.link}
        href='mailto:customersupport@ripplestreet.com'
      >
        customersupport@ripplestreet.com
      </a>
    );
    const termsOfServiceLink = (
      <a
        style={styles.link}
        href={`${process.env.APP_URL}/terms-of-service`}
      >
        Terms of Service
      </a>
    );
    return (
      <div style={styles.container}>
        <div style={style}>
          <p>
            Updated effective October 1, 2021.
          </p>
          <p>
            Welcome to www.ripplestreet.com. This website (this &ldquo;Website&rdquo;) is owned and operated by House
            Party, Inc., d/b/a Ripple Street, a Delaware corporation (&ldquo;Ripple Street&rdquo;, &ldquo;we&rdquo;
            , &ldquo;our&rdquo;, or &ldquo;us&rdquo;).
          </p>
          <p>
            <strong>Our Commitment to Privacy</strong>
          </p>
          <p>
            Ripple Street knows that your privacy is important to you, and we work hard to earn and keep your trust.
          </p>
          <p>
            This Privacy Policy. We have created this Online Privacy Policy (this &ldquo;Privacy Policy&rdquo;) to let
            you know what &ldquo;personal information&rdquo; we collect when you and others use this Website, how we use
            and share the personal information we collect, and some of the steps we take to protect your
            privacy. &ldquo;Personal information&rdquo; is information that identifies you personally, either alone or
            in combination with other information available to us. Examples of personal information include your name,
            address, and email address.
          </p>
          <p>
            Our Commitment to Transparency. Ripple Street is committed to providing the information you need to make
            informed choices about the ways you use this Website and the personal information you share with us. If you
            have any questions about this Privacy Policy or our privacy practices, please contact us by email
            at {privacyEmailLink}, call at (888) 591-1678 (toll-free).
          </p>
          <p>
            <strong>Your Consent to This Privacy Policy</strong>
          </p>
          <p>
            By browsing or using this Website, you are consenting to the collection, use and disclosure of your personal
            information as described in this Privacy Policy. IF YOU DO NOT CONSENT TO THE COLLECTION, USE AND DISCLOSURE
            OF YOUR PERSONAL INFORMATION AS SET FORTH IN THIS POLICY, YOU MAY NOT BROWSE OR USE THIS WEBSITE.
          </p>
          <p>
            <strong>This Privacy Policy is Part of Our Terms of Service.</strong>
          </p>
          <p>
            This Privacy Policy is part of the {termsOfServiceLink} that govern your use of this Website. A link to
            our {termsOfServiceLink} is provided on every page of this Website.
          </p>
          <p>
            <strong>Changes to this Privacy Policy</strong>
          </p>
          <p>
            As we add new features and functionality to this Website, we may need to update or revise this Privacy
            Policy. We reserve the right to do so, at any time and without prior notice, by posting the revised version
            on this Website. These changes will be effective as of the date we post the revised version on this Website.
            They will apply only to the personal information we collect after we have posted the revised version. Your
            use of this Website following any such change constitutes your consent to the terms of the revised Privacy
            Policy. For this reason, it is important to review this Privacy Policy regularly. If we modify this Privacy
            Policy, we will provide a notice at the top of this Privacy Policy for at least 30 days after the new
            effective date. You may access the current version of this Privacy Policy at any time by clicking on the
            link marked &ldquo;Privacy Policy&rdquo; at the bottom of each page of this Website. For your convenience,
            we post the effective date of this Privacy Policy at the top of this page, so that you can see at a glance
            whether this Privacy Policy has changed since your last visit.
          </p>
          <p>
            <strong>Privacy Notices</strong>
          </p>
          <p>
            This Privacy Policy may be supplemented or amended from time to time by &ldquo;privacy notices&rdquo; posted
            on this Website. These privacy notices provide a level of detail that we cannot provide in this more general
            description of our privacy practices. For example, certain pages of this Website contain privacy notices
            providing details about the personal information we collect on those pages, why we need that information,
            and choices you may have about the ways we use that information.
          </p>
          <p>
            <strong>Country-Specific Notices</strong>
          </p>
          <p>
            Privacy requirements vary from country to country. To meet these requirements we have included
            certain &ldquo;country-specific notices&rdquo; as part of this Privacy Policy. If any of the terms of a
            country-specific notice are different than the general terms of this policy, the terms of the
            country-specific notice will supplement or amend this policy, but only to the extent that the laws of that
            country apply to the collection of personal information through this Website.
          </p>
          <p>
            <strong>Other Agreements</strong>
          </p>
          <p>
            Click-Through Agreements. When you sign up to use a special feature or password-protected area of this
            Website, you may be asked to agree to special terms governing your use of the special feature or
            password-protected area. In such cases, you will be asked to expressly consent to the special terms, for
            example, by checking a box or clicking on a button marked &ldquo;I agree.&rdquo; This type of agreement is
            known as a &ldquo;click-through&rdquo; agreement. If any of the terms of the click-through agreement are
            different than the terms of this policy, the terms of the click-through agreement will supplement or amend
            this Privacy Policy, but only with respect to the matters governed by the &ldquo;click-through
            agreement.&rdquo;
          </p>
          <p>
            Release, Waiver of Liability and Indemnity Agreement. When you apply to host a Ripple Street event or use
            this Website to accept an invitation to attend a Ripple Street event, you will be asked to agree to our
            Release, Waiver of Liability and Indemnity Agreement (the &ldquo;Release&rdquo;). The terms of the Release
            supplement and amend this Privacy Policy, but only with respect to the subject matter of the Release. Please
            read the Release carefully. If you do not agree to the terms of the Release, you may not host or attend a
            Ripple Street event.
          </p>
          <p>
            <strong>What Personal Information Do We Collect Through This Website?</strong>
          </p>
          <p>
            We collect three types of personal information through this Website: the personal information you knowingly
            choose to provide or post when you use this Website; personal information collected from your browser or
            using standard Web technologies, such as cookies; and the personal information others may provide about you
            when they post User Generated Content on this Website.
          </p>
          <p>
            Information You Provide. We collect the personal information you knowingly provide (using your mouse and
            keyboard) when you use this Website. The information we collect depends on how you use this Website. For
            example, if you apply to host a party, we collect the information you provide as part of the online
            application process. If you post photographs, comments or other User Generated Content on a party page, we
            collect that information also. All postings must comply with the requirements for User Generated Content as
            set forth in our {termsOfServiceLink}. Information Others Post on This Website. The User Generated Content
            others post on this Website may contain your personal information. For example, if you attend a party,
            someone may post photographs of you and others that were taken at the party. All postings must comply with
            the requirements for User Generated Content as set forth in our {termsOfServiceLink}.
          </p>
          <p>
            Information Sent to Us by Your Web Browser. We collect information that is sent to us automatically by your
            Web browser. This information typically includes your IP address, the identity of your Internet service
            provider, the name and version of your operating system, the name and version of your browser, the date and
            time of your visit, and the pages you visit. Please check your browser if you want to learn what information
            your browser sends or how to change your settings. Generally, we do not link the information provided by
            your browser to information that identifies you by name. You should know, however, that when you access this
            Website by clicking on a link in an email or other electronic communication you receive from us, your
            browser tells us that someone has clicked on a particular link in a communication addressed to you. We
            collect that information to improve the effectiveness of our marketing efforts.
          </p>
          <p>
            More About IP Addresses. An &ldquo;IP address&rdquo; is a unique number that is automatically assigned to
            your computer when you connect to the Internet. It is used to identify your
            computer&rsquo;s &ldquo;location&rdquo; in cyberspace, so that the information you request can be delivered
            to you. If you use a dial-up connection or a connection that assigns dynamic IP addresses, your computer
            will be assigned a new IP Address each time you connect to the Internet. If, however, your computer is
            permanently connected to the Internet using a static IP address, the IP address assigned to your computer
            will generally be the same each time you use your computer.
          </p>
          <p>
            IP addresses do not include your name, email address or other information that identifies you personally,
            but in some cases, they can be used to identify you. For example, if you have created a user identity, for
            example, by joining Ripple Street, we may link your IP address to information that identifies you
            personally. In addition, if, for example, we suspect fraud or a threat to the security of this Website, we
            may share our server logs &ndash; which contain visitors&rsquo; IP addresses -- with the appropriate
            investigative authorities, who could use that information to trace and identify individuals. Because IP
            addresses can be used, under certain circumstances, to trace and identify particular individuals, Ripple
            Street treats them as personal information.
          </p>
          <p>
            Cookies and Similar Technologies. We use &ldquo;cookies&rdquo; and other Web technologies to collect
            information and support certain features of this Website. For example, we may use these technologies to:
          </p>
          <ul style={styles.list}>
            <li>
              collect information about the ways visitors use this Website &ndash; which pages they visit, which links
              they use, and how long they stay on each page;
            </li>
            <li>
              to manage and determine the effectiveness of our advertising and marketing campaigns;
            </li>
            <li>
              to support the features and functionality of this Website &mdash; for example, to save you the trouble of
              reentering information already in our database or to prompt the settings you established on previous
              visits to this Websites; and
            </li>
            <li>
              to personalize your experience when you use this Website.
            </li>
          </ul>
          <p>
            Generally, the information we collect using these Web technologies does not identify you personally. If,
            however, you have created a user identity, for example, by joining Ripple Street or applying to host a
            party, we may link the information we collect using these Web technologies to other information that
            identifies you personally.
          </p>
          <p>
            You can control cookies and tracking tools. Your browser may give you the ability to control cookies or
            other tracking tools. How you do so depends on the type of tool. Certain browsers can be set to reject
            browser cookies. To control flash cookies, which we may use on certain websites from time to time, you can
            go here. Why? Because flash cookies cannot be controlled through your browser settings. If you block cookies
            on your browser, certain features on our sites may not work. If you block or delete cookies, not all of the
            tracking activities we have described here will stop. Choices you make are both browser and driver-specific.
            To learn more about cookies on our site, you can also read our {cookiePolicyLink}.
          </p>
          <p>
            <strong>How Do We Use Your Personal Information?</strong>
          </p>
          <ul style={styles.list}>
            <li>
              We use the personal information we collect through this Website to provide the information, services and
              products you request;
            </li>
            <li>
              to process your application to host a party;
            </li>
            <li>
              to contact you regarding your interest or participation in a Ripple Street event;
            </li>
            <li>
              to contact you about events we believe will be of interest to you (in accordance with any privacy
              preferences you have expressed to us);
            </li>
            <li>
              to contact you with special offers and other information we believe will be of interest to you (in
              accordance with any privacy preferences you have expressed to us);
            </li>
            <li>
              to process your entry, if you enter a sweepstakes or contest;
            </li>
            <li>
              to contact you regarding your use of this Website;
            </li>
            <li>
              to invite you to participate in surveys and provide feedback to us (in accordance with any privacy
              preferences you have expressed to us);
            </li>
            <li>
              to better understand your needs and interests;
            </li>
            <li>
              to improve the content, functionality and usability of this Website;
            </li>
            <li>
              to provide you with a personalized experience when you use this Website;
            </li>
            <li>
              to improve our products and services;
            </li>
            <li>
              to improve our marketing and promotional efforts;
            </li>
            <li>
              for security, credit or fraud prevention purposes;
            </li>
            <li>
              for any other purpose identified in an applicable privacy notice; and
            </li>
            <li>
              for any other purpose identified in a click-through agreement or other agreement between Ripple Street and
              you.
            </li>
          </ul>
          <p>
            &ldquo;Refer-a-Friend.&rdquo; You may use the &ldquo;Refer a Friend&rdquo; feature on this Website to tell
            your friends about Ripple Street. When you do, we ask your for name and email address and for your
            friend&rsquo;s name and email address. We use your name and email address in the &ldquo;From&rdquo; line of
            the email message so that your friend knows who sent the message. We use your friend&rsquo;s name only to
            personalize your message. We use this information only to deliver your message and do not use it to add your
            name or your friend&rsquo;s name to our mailing lists. Please be aware, however, that you or your friend may
            already be on our mailing lists (for example, because you have applied to host a Ripple Street event).
          </p>
          <p>
            Invitations. If you use this Website to invite a friend to a party you are hosting, we may send a separate
            e-mail to your friend explaining what the invitation and Ripple Street are all about, and we may send
            follow-up e-mails regarding the party you are hosting . We will not add your friend&rsquo;s contact
            information to our general mailing list unless your friend decides to register on this Website.
          </p>
          <p>
            Direct Marketing. Before we use your personal information for direct marketing purposes, we will offer you
            the opportunity to opt-in or opt-out, as required by applicable law. To learn more about the choices you
            have about the ways we use your personal information, see below.
          </p>
          <p>
            <strong>How Does Ripple Street Share My Personal Information?</strong>
          </p>
          <p>
            Service Providers. We share personal information with companies and organizations that perform services on
            our behalf, for example, companies that provide support services to us (such as email management services
            and data storage services). These third parties are required by contract to use the personal information we
            share with them only to perform services on our behalf and to treat your personal information as strictly
            confidential.
          </p>
          <p>
            Sponsors. If you apply to host one of our events, we may share your application with the company that is
            sponsoring the event (the &ldquo;Sponsor&rdquo;) to determine whether you and the Sponsor are a good match.
            Where permitted by law and when you &ldquo;opt-in&rdquo; on the application, the Sponsor may also add the
            contact information on your application to its mailing lists and marketing databases and contact you with
            information and offers the Sponsor believes will be of interest to you. If you are selected to host one of
            our events, the Sponsor will use your contact information to contact you regarding the event (before, during
            and after the event). Please be aware that if you communicate directly with the Sponsor or visit the
            Sponsor&rsquo;s Web site, any information you provide to the Sponsor will be governed by the Sponsor&rsquo;s
            privacy policies.
          </p>
          <p>
            If you sign up to attend one of our events as a guest, we may share your contact information with the host
            and the Sponsor, who may use your information to contact you about the event. If
            you &ldquo;opt-in&rdquo; during the registration process, the Sponsor may also add your contact information
            to its mailing lists and contact you with information and offers the Sponsor believes will be of interest to
            you. If you communicate directly with the Sponsor or visit the Sponsor&rsquo;s Web site, any information you
            provide to the Sponsor will be governed by the Sponsor&rsquo;s privacy policies.
          </p>
          <p>
            Our Sponsors have full access to the party pages and national page for their events and may use the User
            Generated Content posted on those pages to advertise and promote their products, services and brands. Please
            see below for more information about the ways User Generated Content is shared and distributed.
          </p>
          <p>
            Other Marketing Partners. From time to time, we may wish to share your personal information with carefully
            selected marketing partners so that they can contact you with information and offers we and they believe
            will be of interest to you. We will not do so, however, unless you have given us your express
            (&ldquo;opt-in&rdquo;) consent.
          </p>
          <p>
            User Generated Content. Ripple Street.com is all about sharing User Generated Content with visitors to this
            Website and with the general public. As used in this Privacy Policy, &ldquo;User Generated
            Content&rdquo; means all of the text, photographs, images, illustrations, graphics, sounds, video and
            audio-video clips, and other content you post on or through this Website, except your Feedback and any part
            of your Account Information that is not included in your Public Profile. User Generated Content includes
            anything you post on a party page and the content of any emails or other communications you send through
            this Website, such as invitations to a party or follow-up communications. Please be aware that User
            Generated Content may be forwarded by email or to other Web sites, such as Facebook.com, using features and
            functionality available through this Website. For example, our national party pages may be displayed on
            other Web sites, on cell phones and other mobile devices, and in other media using the RSS feed available
            through this Website. All User Generated Content must comply with our {termsOfServiceLink}, and only
            Registered Users may post User Generated Content.
          </p>
          <p>
            You post User Generated Content at your own risk. You should have no expectation of privacy with respect to
            the User Generated Content you or others post. You should not post any User Generated Content you do not
            wish to make permanently available to the general public, and you must take special care to make sure your
            postings do not violate the privacy or other rights of others. If, at any time, you wish us to take down
            User Generated Content that contains your personal information, please contact us by email
            at {privacyEmailLink} and we will work with you to remove the User Generated Content from this Website.
            Please be aware, however, that if the User Generated Content has already been distributed to other Websites
            or published in other media (for example, via an RSS Feed), we will not be able to recapture it and delete
            it from third-party Websites or other media.
          </p>
          <p>
            Your Account Information and Public Profile. When you register on this Website, you will be required to
            provide certain personal information to us. This information becomes part of your Ripple Street account
            information (your &ldquo;Account Information&rdquo;) and some of this information becomes part of
            your &ldquo;Public Profile.&rdquo; Your Account Information includes your personal details (such as your
            name, contact information, shipping address, screen name and password), your photograph, and your contact
            preferences. Your Account Information is password protected. Your Public Profile is the information that
            others will see if they click on your screen name or User Generated Content you have posted. Your Public
            Profile includes your screen name, age, gender and photograph (unless you choose to use an icon instead of a
            photograph). Your Public Profile also tells people how many photos, videos, and blog posts you have posted.
          </p>
          <p>
            Business Transfers. Your personal information may be transferred to a company that has acquired the stock or
            assets of Ripple Street or one of our businesses, for example, as the result of a sale, merger,
            reorganization or liquidation. If such a transfer occurs, the acquiring company&rsquo;s use of your personal
            information will still be subject to this Privacy Policy and the privacy preferences you have expressed to
            us.
          </p>
          <p>
            Compliance With Laws and Protection of Our Rights and the Rights of Others. We may disclose personal
            information when we, in good faith, believe disclosure is appropriate to comply with the law, a court order
            or a subpoena. We may also disclose personal information to prevent or investigate a possible crime, such as
            fraud or identity theft; to enforce or apply our online {termsOfServiceLink} or other agreements; or to
            protect our own rights or property or the rights, property or safety of our users or others.
          </p>
          <p>
            As Described in a Privacy Notice. We reserve the right to disclose your personal information as described in
            any Privacy Notice posted on the Web page (or area) where you provide that information. By providing your
            personal information on that Web page you will be consenting to the disclosure of your personal information
            as described in that Privacy Notice.
          </p>
          <p>
            As Described in a Click-Through Agreement. We reserve the right to disclose your personal information as
            described in any click-through agreement to which you have agreed, including our Release.
          </p>
          <p>
            Age verification. Ripple Street currently uses the following procedures in the event that you submit
            information via the Website for age and/or indentify verification purposes in connection with your
            registration for certain activities or events, such as product demonstrations, parties, and sampling,
            educational and informational activities (collectively &ldquo;Activities&rdquo;) for which Ripple Street has
            implemented age and/or identification verification procedures. Anyone wishing to register for such
            Activities will need to submit to Ripple Street&rsquo;s current age and/or identity verification procedures.
            It is important to note that submitting to the verification process is completely voluntary. Individuals who
            choose not to submit to the verification process will not be allowed to register or attend such Activities.
            The information that you may need to submit for such verification activities may vary depending on the
            activity, and may include your: passport, driver&rsquo;s license, national ID number and/or social security
            number (or a portion thereof). In addition, you may be required to provide simple details about your
            identity; generally, this includes information such as your: name, date of birth, and address. The
            information you submit in connection with the verification process is provided to a third party verification
            provider, which is cross-checked against pre-existing databases to verify your identity and age. Our
            verification provider will assess the consistency of the information you submit to us and return a code to
            us that indicates whether the information you submitted matches the information in the verification
            provider&rsquo;s database. We do not store the information you submit to us in connection with the
            verification process. However, we do store the code returned by our verification provider indicating whether
            the information you submitted to us matches the information in the verification provider&rsquo;s database.
          </p>
          <p>
            <strong>Your Choices</strong>
          </p>
          <p>
            In General
          </p>
          <p>
            We respect your right to make choices about the ways we collect, use and disclose your personal information.
            In most cases, we will ask you to indicate your choices at the time we collect your personal information. If
            you have registered on this Website, you may update some of your privacy choices by changing your account
            settings.
          </p>
          <p>
            Direct Marketing
          </p>
          <p>
            Before we use your personal information for direct marketing purposes we will offer you the opportunity to
            choose (by opting out or opting in, depending on applicable law) whether to have your information used in
            this way. We will also include an &ldquo;opt-out&rdquo; link in any promotional email we send you, so that
            you can inform us that you do not wish to receive such communications from us in the future. If at any time
            you wish to be taken off our mailing lists, please send an email us at {privacyEmailLink}. Please
            provide your full name, address and email address so that we can find you on our direct marketing mailing
            lists. Once we have the information we need, we will remove you from our mailing lists. Please give us a
            reasonable amount of time to honor your request.
          </p>
          <p>
            Sharing Your Personal Information.
          </p>
          <p>
            Please review the section entitled &ldquo;How Does Ripple Street Share My Personal Information?&rdquo; to
            learn how we may share your personal information with third parties and the general public and what choices
            you have about purposes for which we may share your personal information with third parties and the general
            public.
          </p>
          <p>
            <strong>How Can You Access, Update or Correct Your Personal Information?</strong>
          </p>
          <p>
            If you have created an account or a personal profile on this Website, you may update your account
            information, including your contact information and privacy preferences, by logging into your account. In
            other cases, you will need our help to access and update your personal information. If you wish to know what
            personal information about you we have stored in our databases or if you wish to update or correct your
            personal information, please send us an email at {privacyEmailLink}. We will respond to you
            within a reasonable time and within the time limits established by applicable law. We may ask you for
            additional information to verify your identity. In most cases, we will provide information about the
            personal information stored in our databases and correct or delete any inaccurate information you discover.
            In some cases, however, we may limit or deny your request if the law permits or requires us to do so or if
            we are unable to verify your identify. Although generally we do not charge for these services, we reserve
            the right, at our discretion, to charge a reasonable fee as permitted by applicable law. We will notify you
            if a fee will apply in your case.
          </p>
          <p>
            <strong>How Can You Delete Your Data or Account?</strong>
          </p>
          <p>
            If you’d like to either delete your personal information or delete the account you have created on this Website,
            please send us an email at {csEmailLink}.
            We will respond to you within a reasonable time and within the time limits established by applicable law.
            We may ask you for additional information to verify your identity.
            Once verified, we will process your request and confirm the requested changes once complete.
          </p>
          <p>
            <strong>How do we protect your personal information?</strong>
          </p>
          <p>
            We maintain a comprehensive data security program, including commercially reasonable administrative,
            physical and technological security measures, to protect your personal information from unauthorized access,
            unauthorized use, and unauthorized or accidental destruction, modification or disclosure. Although we take
            commercially reasonable precautions to provide a level of security appropriate to the sensitivity of the
            personal information we collect, no website or database is completely secure or &ldquo;hacker
            proof.&rdquo; We therefore cannot guarantee that your personal information will not be disclosed, misused or
            lost by accident or by the unauthorized acts of others.
          </p>
          <p>
            <strong>Password Protected Areas of This Website</strong>
          </p>
          <p>
            For your protection, certain areas of this Website are password protected. You are responsible for
            maintaining the confidentiality of your passwords. We have the right to assume that anyone accessing this
            Website using a password assigned to you has the right to do so. You will be solely responsible for the
            activities of anyone accessing this Website using a password assigned to you, even if the individual is not,
            in fact authorized by you. If you have reason to believe that your password has been compromised or used
            without authorization, you must promptly change it using the functionality provided on this Website.
          </p>
          <p>
            <strong>We Collect and Store Information Inside the United States</strong>
          </p>
          <p>
            Ripple Street is a U.S. corporation based in Irvington, New York, in the United States of America. Our Web
            servers are located in the United States. We may transfer your personal information to our service providers
            and others located in the United States or in other countries for the purposes described in this Privacy
            Policy. Our registration process only allows for the collection of data from U.S. and Canadian residents.
            Different countries have different privacy laws and requirements, and some provide less legal protection for
            your personal information than others. Please know, however, that no matter where your personal information
            is collected, used, transferred or stored, if it was collected through this Website, it will be protected by
            the terms of this Privacy Policy and any privacy notices, country-specific notices and click-through
            agreements that apply to you.
          </p>
          <p>
            BY USING THIS WEBSITE, YOU ARE CONSENTING TO THE COLLECTION, USE, AND TRANSFER OF YOUR PERSONAL INFORMATION
            IN OR TO THE UNITED STATES OR TO ANY OTHER COUNTRY IN THE WORLD SUBJECT TO THE TERMS OF THIS POLICY.
          </p>
          <p>
            <strong>Links to Third-Party Web Websites</strong>
          </p>
          <p>
            This Website may also contain links to websites operated by other companies, including websites operated by
            our third-party service providers, our Sponsors, and other third parties. This Privacy Policy does not apply
            to personal information collected on any of these third-party Web sites. When you access third-party
            websites through a link on this Website, please take a few minutes to review privacy policy posted on that
            site.
          </p>
          <p>
            <strong>What Personal Information Do We Collect From Children?</strong>
          </p>
          <p>
            Ripple Street does not knowingly collect personal information from anyone under eighteen (18) years of age.
            If you are under 14, do not use this Website to provide personal information to us. If you believe that a
            person under the age of 18 has provided personal information through this Website, please contact us by
            email at {privacyEmailLink}. We will work with you to identify and delete information provided by
            anyone under the age of 18. Ripple Street does not knowingly collect personal information from anyone under
            eighteen (18) years of age without first obtaining verifiable parental consent if required to do so by
            applicable law. If you believe we have collecting information from anyone under 18 in violation of
            applicable law, please contact us by email at {privacyEmailLink}. We will work with you to identify
            and delete information collected from minors under the age of 18 in violation of applicable law.
          </p>
          <p>
            <strong>Notice to California Residents</strong>
          </p>
          <p>
            In compliance with the California Civil Code Section 1798.83, residents of California are hereby notified
            that the Site, the services and the appertaining personal data are safeguarded by us. Our users can obtain
            certain information about the personal data we may have access to, including disclosure thereof with third
            parties for direct marketing purposes (e.g. names and addresses of those third parties, types of services or
            products marketed thereby). If you wish to request a copy of your information disclosure, please contact us
            at {ccpaEmailLink}.
          </p>
          <p>
            <strong>California Online Privacy Protection Act</strong>
          </p>
          <p>
            In compliance with CalOPPA, we have hereby posted this conspicuous Policy to the public, indicating the
            personal data being collected and the manner in which it may be disclosed and with whom. Accordingly, our
            users can may visit our Site using anonymous browsing, this Policy linked in our home page, with the link
            including the word ‘Privacy’ or similar. We also comply with Policy change notification to our users, and
            provide mechanisms that allow our users to manage their personal data personal information.
          </p>
          <p id='cookie-policy'>
            <strong>Cookie Policy</strong>
          </p>
          <p>
            Ripple Street uses cookies on its website. Cookies are small files which download when you access certain
            websites. To learn more, visit here or here. These pages also explain how you can manage and delete cookies.
          </p>
          <p>
            We use cookies to improve our site and the experience of our visitors. We use these cookies to collect
            information about how visitors use our website. For example, we collect details of the site where the
            visitor has come from and the total number of times a visitor has been to our website.
          </p>
          <p>
            To find out more about how to enable, disable or delete cookies from your web browser, please visit here and
            here.
          </p>
          <p>
            <strong>Governing Law</strong>
          </p>
          <p>
            This Privacy Policy is governed under the laws of the State of New York, United States of America without
            regard to its conflicts of law provisions.
          </p>
        </div>
      </div>
    );
  }
}
